import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

/**
 * This component is used to display global validation error of a form. Generally if there is a validation that 
 * involves more than a field, the validation messages are displayed with this component placed on the top of the edit/create form.
 */
@Component({
  selector: 'validation-error-bar',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatIcon],
  templateUrl: './validation-error-bar.component.html',
  styleUrl: './validation-error-bar.component.css'
})
export class ValidationErrorBarComponent {

  @Input() formGroup!: FormGroup;

  /**
   * Format: 
   * {
   *   'nameOfTheFormField': 'validation.label',
   * }
   */
  @Input() validationMessages: Record<string, string> = {};

  /**
   * Optional: List of controls that should be touched before showing the error
   */
  @Input() relevantControls: string[] = [];

  shouldShowError(errorKey: string): boolean {
    const hasError = this.formGroup.errors?.[errorKey];
    const controlsTouched = this.relevantControls.length === 0 ||
      this.relevantControls.some(controlName =>
        this.formGroup.get(controlName)?.touched
      );
    return hasError && controlsTouched;
  }

  get errorKeys(): string[] {
    return Object.keys(this.validationMessages);
  }

}
